import React, { createContext, type ReactNode, useContext, useMemo } from 'react'
import { type TreeId } from '@fs/zion-tree-types'
import useGedcomDataHook from '../services/useGedcomDataHook'

type GedcomDataValue = {
  gedcomData: ReturnType<typeof useGedcomDataHook>['data']
  refetchGedcomData: ReturnType<typeof useGedcomDataHook>['refetch']
}

const GedcomDataContext = createContext<GedcomDataValue | undefined>(undefined)

export const useGedcomData = (): GedcomDataValue => {
  const context = useContext(GedcomDataContext)
  if (!context) throw new Error('You need to use the GedcomDataProvider to use useGedcomData')
  return context
}

type Props = {
  treeId: TreeId | undefined
  children: ReactNode
}
export default function GedcomDataProviderSmart({ treeId, children }: Props): JSX.Element {
  const { data, refetch } = useGedcomDataHook(treeId)
  const value = useMemo(() => ({ gedcomData: data, refetchGedcomData: refetch }), [data, refetch])
  return <GedcomDataContext.Provider value={value}>{children}</GedcomDataContext.Provider>
}
